/* global console, module, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const AppRouter = require('marionette.approuter'),
    BackboneRadio = require('backbone.radio'),
    _ = require('lodash');

module.exports =  AppRouter.extend({
    appRoutes: {
        'administrators': 'administrators',
        'dashboard':      'dashboard',
        'organizations':  'organizations',
        'reports':        'reports',
        'popout/:id':     'popout',
        'popoutPrograms': 'popoutPrograms',
        'program/:id':    'program', // @acavan! - shouldn't we use this route when programDetails are displayed?
        'programs':       'programs'
    },
    channel: BackboneRadio.channel('router'),
    // controller: {},
    initialize: function () {
        let hash = window.location.hash.substr(1);
        this.controller = {
            administrators: _.bind(function () {
                // console.log('@router.administrators');
                this.channel.trigger('newRoute', {name: 'dashboard', panel: 'administrators'});
            }, this),
            // the 'panel' logic should probably be in container and 'name' just reflect the hash
            dashboard: _.bind(function () {
                // console.log('@router.dashboard');
                // window.location = '#organizations';
                this.channel.trigger('newRoute', {name: 'dashboard', panel: '*'});
            }, this),
            organizations: _.bind(function () {
                // console.log('@router.organizations');
                this.channel.trigger('newRoute', {name: 'dashboard', panel: 'organizations'});
            }, this),
            reports: _.bind(function () {
                // console.log('@router.reports');
                this.channel.trigger('newRoute', {name: 'dashboard', panel: 'reports'});
            }, this),
            popout: _.bind(function (id) {
                // console.log('@router.popout');
                this.channel.trigger('newRoute', {name: 'popout', id: +id, popout: true});
            }, this),
            popoutPrograms: _.bind(function () {
                // console.log('@router.popoutPrograms');
                this.channel.trigger('newRoute', {name: 'popoutPrograms', popout: true});
            }, this),
            program: _.bind(function (id) {
                // console.log('@router.program');
                this.channel.trigger('newRoute', {name: 'program', id: +id});
            }, this),
            programs: _.bind(function () {
                // console.log('@router.programs');
                this.channel.trigger('newRoute', {name: 'programs'});
            }, this)
        };
        if (hash.length === 0 || !this.controller[hash.split('/')[0]]) {
            // console.log('@router.#programs');
            window.location = '#programs';
        }
    }
});
